const CLOUDINARY_CONFIG = {
  cloudName:  "drgzdpz6l",
  apiKey:     "759811929795227",
  apiSecret:  "9FYgXv2o9MnFXg7qmWwVHH5hoM0",
  uploadPreset: "consultec_obras"
};

export async function uploadFotoObra(file, metadata) {
  const { projectId, zona, lat, lng, userId } = metadata;
  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", CLOUDINARY_CONFIG.uploadPreset);
  formData.append("folder", `consultec/${projectId}/${zona}`);
  formData.append("context", `lat=${lat}|lng=${lng}|zona=${zona}|user=${userId}`);
  formData.append("tags", `${projectId},${zona},obra`);
  const res = await fetch(
    `https://api.cloudinary.com/v1_1/${CLOUDINARY_CONFIG.cloudName}/image/upload`,
    { method: "POST", body: formData }
  );
  const data = await res.json();
  return {
    url:       data.secure_url,
    publicId:  data.public_id,
    width:     data.width,
    height:    data.height,
    createdAt: data.created_at,
    lat, lng, zona, projectId
  };
}

export async function deleteFotoObra(publicId) {
  console.log("Delete:", publicId);
}

export default CLOUDINARY_CONFIG;
